import React, { useState } from 'react'
import { Search, Plus } from 'lucide-react'

import { Input } from '../../../components/ui/input'
import { SellerCard } from '../components/SellerCard'
import { Spinner } from '../../../components/ui/spinner'
import { FilterSeller } from '../components/SellerFilter'
import { Button } from '../../../components/ui/button'
import { CreateSellerModal } from '../components/CreateSellerModal'
import { useAuth } from '../../../../app/hooks/useAuth'
import { useSellersPageController } from './useSellersPageController'
import { useWhitelabelContext } from '@/app/contexts/whitelabelContext'

export const SellersPage = () => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false)
  const { isAdmin } = useAuth()
  const { appConfig } = useWhitelabelContext()

  const {
    data,
    handleSearchInputChange,
    handleSellerDetailsPage,
    searchValue,
    isFetchingNextPage,
    hasNextPage,
    isFetching,
    ref,
  } = useSellersPageController()

  return (
    <div>
      <h2 className="mb-8 text-2xl font-semibold text-info">
        Gerenciar vendedores ({data?.pages[0].pagination.total})
      </h2>
      <div className="mb-8 flex items-center justify-between">
        <div className="relative flex items-center">
          <Search size={20} className="z-2 absolute left-4 top-3" />
          <Input
            className="ml-1 w-52 rounded-3xl pl-10 md:w-72"
            placeholder="Pesquisar vendedor"
            onChange={handleSearchInputChange}
            value={searchValue}
          />
        </div>
        <div className="flex items-center space-x-2">
          {isAdmin && appConfig?.CAN_REGISTER_SELLER && (
            <Button
              onClick={() => setIsCreateModalOpen(true)}
              className="flex items-center space-x-2 text-white"
            >
              <Plus size={16} />
              <span>Criar Vendedor</span>
            </Button>
          )}
          <FilterSeller />
        </div>
      </div>
      <div className="space-y-4">
        <div className="grid grid-cols-sellerCards gap-4">
          {data &&
            data.pages.map((page, index) => (
              <React.Fragment key={index}>
                {page.users.map((seller) => (
                  <SellerCard
                    key={seller._id}
                    _id={seller._id}
                    name={seller.name}
                    profileImageUrl={seller.profileImageUrl}
                    team={seller.team}
                    transactions={seller.transactions}
                    handleSellerDetailsPage={handleSellerDetailsPage}
                    isActive={seller.isActive}
                    isRemove={false}
                  />
                ))}
              </React.Fragment>
            ))}
        </div>

        <div className="mt-2 flex items-center justify-center" ref={ref}>
          <Button variant="ghost" disabled={!hasNextPage || isFetchingNextPage}>
            {isFetchingNextPage ? <Spinner /> : null}
          </Button>
        </div>
        <div>
          {isFetching && !isFetchingNextPage ? (
            <div className="flex items-center justify-center">
              <Spinner />
            </div>
          ) : null}
        </div>
      </div>

      <CreateSellerModal
        isOpen={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
      />
    </div>
  )
}
